export default "__VITE_ASSET__BCywminp__"